import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const WaypointTypeSelect = styled.select`
  width: 220px;
  height: 40px;
  border: 1px solid ${Colors.Gray};
  border-radius: 4px;
  padding: 8px 16px 8px 12px;
  outline: none;
  box-sizing: border-box;
  position: fixed;
  left: 40px;
  top: 170px;
`;
